import { useState, useEffect } from 'react';
import search from "../../assets/images/search.png";
import PaginationTable from "../status/PaginationTable";
import "./InstituteTables.css";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import axiosInstance from "../../helpers/axios";
import { Grid, Button, Autocomplete, TextField, InputAdornment } from '@mui/material';
import { Card } from 'reactstrap';
import AddDirectPartner from "./AddDirectPartner";
import ClearIcon from '@mui/icons-material/Clear';
import { useCurrentUser } from '../../hooks/useCurrentUser';

const PartnerTables = () => {
  const decode = useCurrentUser();
  const user = null;
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalFetchRows, setTotalFetchRows] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [id, setId] = useState(null);
  const [isSearched, setIsSearched] = useState(false);

  const [partnerOptions, setPartnerOptions] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [loadingOptions, setLoadingOptions] = useState(false);

  const handleAddPartner = (newPartner) => {
    setTableData((prevTableData) => [...prevTableData, newPartner]);
    setTotalFetchRows((prev) => prev + 1);
  };

  const fetchInitialData = () => {
    setIsLoading(true);
    const getPartners = `/channel-partners/DirectPartners?perPage=${rowsPerPage}&pageNo=${currentPage}`;

    axiosInstance.get(getPartners, {
      headers: {
      },
    })
    .then((res) => {
      setTableData(res?.data?.data?.partners || res?.data?.data || []);
      setCurrentPage(res?.data?.data?.pagination?.currentPage || 1);
      setTotalFetchRows(res?.data?.data?.pagination?.totalRows || res?.data?.data?.length);
      setRowsPerPage(res?.data?.data?.pagination?.perPage || 10);
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    })
    .catch((error) => {
      setIsLoading(false);
      alert(error?.response?.data?.message);
      console.error("Error fetching partners data:", error);
    });
  };

  useEffect(() => {
    fetchInitialData();
  }, []);

  const getPartnerInfo = (text) => {
    const urlGetPartner = `/channel-partners/direct-partner-name?name=${text}`;
    
    if (text.length >= 4) {
      setLoadingOptions(true);
      axiosInstance.get(urlGetPartner, {
        headers: {
        }
      })
      .then((res) => {
        const options = res?.data?.data?.map((partner) => ({
          label: partner.name,
          id: partner.partnerId
        })) || [];
        setPartnerOptions(options);
        setLoadingOptions(false);
      })
      .catch((error) => {
        console.error("Error fetching partner info:", error);
        setLoadingOptions(false);
        setPartnerOptions([]);
      });
    } else {
      setPartnerOptions([]);
    }
  };

  const handleAutocompleteInputChange = (event, newInputValue) => {
    setInputValue(newInputValue);
    setSearchText(newInputValue);
    getPartnerInfo(newInputValue);
  };

  const handlePartnerSelect = (event, newValue) => {
    setSelectedPartner(newValue);
    if (newValue) {
      setId(newValue.id);
      setSearchText(newValue.label);
    } else {
      setId(null);
      setSearchText("");
    }
  };

  const handleInputChange = () => {
    if (!id) {
      alert("Please select a partner name from the dropdown");
      return;
    }

    const getPartners = `/channel-partners/directParnterById?partnerId=${id}&perPage=${rowsPerPage}&pageNo=${1}`;
    axiosInstance.get(getPartners, {
      headers: {
      },
    })
    .then((res) => {
      setTableData(res?.data?.data?.partners || res?.data?.data || []);
      setCurrentPage(1);
      setTotalFetchRows(res?.data?.data?.pagination?.totalRows || res?.data?.data?.length);
      setRowsPerPage(res?.data?.data?.pagination?.perPage || 10);
      setIsSearched(true);
    })
    .catch((error) => {
      console.error("Error fetching filtered data:", error);
      alert("Error fetching filtered data");
    });
  };

  const handleClearSearch = () => {
    setSearchText("");
    setInputValue("");
    setSelectedPartner(null);
    setId(null);
    setIsSearched(false);
    setCurrentPage(1);
    setPartnerOptions([]);
    fetchInitialData();
  };

  const paginate = (pageNumber) => {
    
    if (searchText.length >= 4 && id) {
      const getPartners = `/channel-partners/directParnterById?partnerId=${id}&perPage=${rowsPerPage}&pageNo=${pageNumber}`;
      
      axiosInstance.get(getPartners, {
        headers: {
        },
      })
      .then((res) => {
        setTableData(res?.data?.data?.partners || res?.data?.data || []);
        setCurrentPage(res?.data?.data?.pagination?.currentPage || pageNumber);
        setTotalFetchRows(res?.data?.data?.pagination?.totalRows || res?.data?.data?.length);
        setRowsPerPage(res?.data?.data?.pagination?.perPage || 10);
      })
      .catch((error) => {
        console.error("Error fetching filtered data:", error);
      });
    } else {
      const getPartners = `/channel-partners/DirectPartners?perPage=${rowsPerPage}&pageNo=${pageNumber}`;

      axiosInstance.get(getPartners, {
        headers: {
        },
      })
      .then((res) => {
        setTableData(res?.data?.data?.partners || res?.data?.data || []);
        setCurrentPage(res?.data?.data?.pagination?.currentPage || pageNumber);
        setTotalFetchRows(res?.data?.data?.pagination?.totalRows || res?.data?.data?.length);
        setRowsPerPage(res?.data?.data?.pagination?.perPage || 10);
      })
      .catch((error) => {
        console.error("Error fetching filtered data:", error);
      });
    }
  };
  
  return (
    <Card style={{ width: "100%", backgroundColor: 'white', minHeight: '100vh' }}>
        <div>
          <h1 style={{ fontFamily: 'Inter-Medium', fontSize: '1vw', fontWeight: '500', color: '#D32028', marginTop: '10px', marginLeft: '5px' }}>
            Partners
          </h1>

          <Grid container spacing={2} alignItems="center" justifyContent="flex-start" flexWrap="wrap" sx={{ marginTop: '20px' }}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Box display="flex" gap={3} alignItems="center">
                {/* 🔶 NEW: Autocomplete component with dropdown (similar to InstituteAutocomplete) */}
                <Autocomplete
                  value={selectedPartner}
                  onChange={handlePartnerSelect}
                  inputValue={inputValue}
                  onInputChange={handleAutocompleteInputChange}
                  options={partnerOptions}
                  loading={loadingOptions}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  getOptionLabel={(option) => option.label || ""}
                  noOptionsText="No partners found"
                  sx={{
                    width: '230px',
                    '& .MuiOutlinedInput-root': {
                      height: '34px',
                      borderRadius: '5px',
                      fontFamily: 'Inter',
                      fontSize: '14px',
                      marginTop: '3px',
                      padding: '0 !important',
                      '& fieldset': {
                        borderColor: '#CACCCE',
                      },
                    },
                    '& .MuiAutocomplete-input': {
                      padding: '0 4px 0 8px !important',
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Partner Name"
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <>
                            <InputAdornment position="start">
                              <img src={search} alt="search" style={{ width: '18px', height: '18px', marginLeft: '8px' }} />
                            </InputAdornment>
                            {params.InputProps.startAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />

                {!isSearched ? (
                  <Button
                    onClick={handleInputChange}
                    sx={{
                      height: '34px',
                      backgroundColor: '#D22129',
                      color: 'white',
                      borderRadius: '5px',
                      fontFamily: 'Inter-Medium',
                      textTransform: 'none',
                      marginBottom: '12px',
                      px: 2,
                      '&:hover': {
                        backgroundColor: '#b81c22',
                      },
                    }}
                  >
                    Search Results
                  </Button>
                ) : (
                  <Button
                    onClick={handleClearSearch}
                    startIcon={<ClearIcon />}
                    sx={{
                      height: '34px',
                      backgroundColor: '#6c757d',
                      color: 'white',
                      borderRadius: '5px',
                      fontFamily: 'Inter-Medium',
                      textTransform: 'none',
                      marginBottom: '12px',
                      px: 2,
                      '&:hover': {
                        backgroundColor: '#5a6268',
                      },
                    }}
                  >
                    Clear
                  </Button>
                )}
              </Box>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Box display="flex" gap={3} justifyContent={'flex-end'}>
                <AddDirectPartner onAddPartner={handleAddPartner} />
              </Box>
            </Grid>
          </Grid>

          {isLoading ? (
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '15%', backgroundColor: 'white', height: '100vh' }}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              <div className='tables' style={{ marginTop: '10px' }}>
                <table>
                  <thead className='table-heading' style={{ width: '100%' }}>
                    <tr>
                      <th style={{ fontSize: '14px', fontFamily: "Inter", width: '13em', borderTopLeftRadius: '8px' }}>
                        <span style={{ marginLeft: '10px' }}>Partner Name</span>
                      </th>
                      <th style={{ fontSize: '14px', fontFamily: "Inter", width: '10em' }}>
                        <span style={{ marginLeft: '10px' }}>Mobile</span>
                      </th>
                      <th style={{ fontSize: '14px', fontFamily: "Inter", width: '13em' }}>
                        <span style={{ marginLeft: '10px' }}>Email</span>
                      </th>
                      <th style={{ fontSize: '14px', fontFamily: "Inter", width: '8em' }}>
                        <span style={{ marginLeft: '10px' }}>PAN</span>
                      </th>
                      <th style={{ fontSize: '14px', fontFamily: "Inter", width: '13em' }}>
                        <span style={{ marginLeft: '10px' }}>Bank Acc. Number</span>
                      </th>
                      <th style={{ fontSize: '14px', fontFamily: "Inter", width: '8em' }}>
                        <span style={{ marginLeft: '10px' }}>IFSC</span>
                      </th>
                      <th style={{ fontSize: '14px', fontFamily: "Inter", width: '13em', borderTopRightRadius: '8px' }}>
                        <span style={{ marginLeft: '10px' }}>Beneficiary Name</span>
                      </th>
                    </tr>
                  </thead>

                  {tableData.map((item, index) => {
                    return (
                      <tbody className='table-body' key={index}>
                        <tr className='table-row' style={{ lineHeight: '14px' }}>
                          <td title={item.name}>
                            <span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px', lineHeight: '1.5em', display: "block", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '13em' }}>
                              {item?.name?.charAt(0)?.toUpperCase() + item?.name?.slice(1)?.toLowerCase() || '-'}
                            </span>
                          </td>
                          <td title={item.phone}>
                            <span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px', lineHeight: '1.5em', display: "block", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '10em' }}>
                              {item.phone || '-'}
                            </span>
                          </td>
                          <td title={item.email}>
                            <span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px', lineHeight: '1.5em', display: "block", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '13em' }}>
                              {item.email || '-'}
                            </span>
                          </td>
                          <td title={item.pan}>
                            <span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px', lineHeight: '1.5em', display: "block", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '8em' }}>
                              {item.pan || '-'}
                            </span>
                          </td>
                          <td title={item.bankAccountNumber}>
                            <span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px', lineHeight: '1.5em', display: "block", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '13em' }}>
                              {item.bankAccountNumber || '-'}
                            </span>
                          </td>
                          <td title={item.ifsc}>
                            <span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px', lineHeight: '1.5em', display: "block", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '8em' }}>
                              {item.ifsc || '-'}
                            </span>
                          </td>
                          <td title={item.beneficiaryName}>
                            <span style={{ color: '#667085', fontFamily: 'Inter', fontSize: '14px', lineHeight: '1.5em', display: "block", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '13em' }}>
                              {item.beneficiaryName || '-'}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    );
                  })}
                </table>
              </div>

              {totalFetchRows ? (
                searchText && totalFetchRows <= 10 ? (
                  <div style={{ textAlign: 'center', fontWeight: 'bold', fontFamily: "Inter", fontSize: '14px', marginLeft: '10px', marginBottom: '5px' }}>
                    Showing {totalFetchRows}-{totalFetchRows} records
                  </div>
                ) : (
                  <div style={{ textAlign: 'center', fontWeight: 'bold', fontFamily: "Inter", fontSize: '14px', marginLeft: '10px', marginBottom: '5px' }}>
                    Showing {currentPage * rowsPerPage + 1 - rowsPerPage}-{Math.min(currentPage * rowsPerPage, totalFetchRows)} records
                  </div>
                )
              ) : (
                <div style={{ textAlign: 'center', fontWeight: 'bold', fontFamily: "Inter", fontSize: '14px' }}>No Records</div>
              )}
              <PaginationTable
                startPage={searchText !== "" ? 1 : currentPage}
                rowsPerPage={rowsPerPage}
                totalRows={totalFetchRows}
                paginate={paginate}
                searchText={searchText}
              />
            </>
          )}
        </div>
    </Card>
  );
};

export default PartnerTables;